export default __webpack_public_path__ + "static/media/pencil-button.92ffee4e.svg";